import { softwareOnboardingPageEntryPoint } from '@jira/spa-apps__software-onboarding/src/SoftwareOnboardingPage.entrypoint.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { jswOnboardingResource } from '@jira/router-resources__software-onboarding/src/jswOnboardingResource.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { softwareOnboardingRoute } from '@jira/router-routes__software-onboarding-routes/src/softwareOnboardingRoute.tsx';

import { projectCreatePermissionsResource } from '@jira/router-resources__project-permissions/src/projectCreatePermissionsResource.tsx';
import { rovoEntitlementResource } from '@jira/router-resources__rovo-entitlement/src/useRovoEntitlementResource.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { fg } from '@atlassian/jira-feature-gating';

import type { Route } from '@atlassian/react-resource-router';
import { SoftwareOnboardingPage, LazySoftwareOnboardingPage } from './ui/index.tsx';

const softwareOnboardingEntryPoint = createPageEntryPoint({
	main: softwareOnboardingPageEntryPoint,
});

export const softwareOnboardingRouteEntry: Route = createEntry(softwareOnboardingRoute, () => ({
	group: 'software',
	// eslint-disable-next-line no-restricted-syntax
	component: SoftwareOnboardingPage,
	layout: chromelessLayout,

	entryPoint: () => softwareOnboardingEntryPoint,

	resources: [
		jswOnboardingResource,
		...jiraSpaResources(),
		projectCreatePermissionsResource,
		resourceWithCondition(
			() => fg('add_rovo_check_resource_to_onboarding'),
			rovoEntitlementResource,
		),
	],

	forPaint: [LazySoftwareOnboardingPage],

	canTransitionIn: () => false,

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
